module.exports = __webpack_public_path__ + "assets/img/box-1.41b8a3ad.png";